import { api } from 'app/app.api';

import {
  CreateWebformEndpointApiArg,
  CreateWebformEndpointApiResponse,
  DeleteWebformEndpointApiArg,
  DeleteWebformEndpointApiResponse,
  ReadWebformEndpointsApiArg,
  ReadWebformEndpointsApiResponse,
} from './types/webformEndpointsApi';

const webformEndpointPath = 'webform-endpoints' as const;

export const webformEndpointsApi = api
  .enhanceEndpoints({
    addTagTypes: ['WebformEndpoint'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readWebformEndpoints: builder.query<
        ReadWebformEndpointsApiResponse,
        ReadWebformEndpointsApiArg
      >({
        query: ({ formIntegrationId }) => ({
          version: 1,
          path: webformEndpointPath,
          params: { formIntegrationId },
        }),
        providesTags: (result, _error, _arg) =>
          result
            ? [
                ...result.data.endpoints.map(({ id }) => ({
                  type: 'WebformEndpoint' as const,
                  id,
                })),
                'WebformEndpoint',
              ]
            : ['WebformEndpoint'],
      }),
      createWebformEndpoint: builder.mutation<
        CreateWebformEndpointApiResponse,
        CreateWebformEndpointApiArg
      >({
        query: (body) => ({
          version: 1,
          method: 'POST',
          path: webformEndpointPath,
          body,
        }),
        invalidatesTags: [{ type: 'WebformEndpoint' }],
      }),
      deleteWebformEndpoint: builder.mutation<
        DeleteWebformEndpointApiResponse,
        DeleteWebformEndpointApiArg
      >({
        query: ({ webformId }) => ({
          version: 1,
          method: 'DELETE',
          path: `${webformEndpointPath}/${webformId}`,
        }),
        invalidatesTags: (_result, error, { webformId }) =>
          error ? [] : [{ type: 'WebformEndpoint', id: webformId }],
      }),
    }),
  });
